module.exports = __webpack_public_path__ + "static/media/user.27ab7bd3.jpg";